import {
    LAWYER_PACKAGES
  } from '../constants/types';

  export default function(state=[], action){
    switch(action.type){
      case LAWYER_PACKAGES:
        return action.payload
      default:
        return state
    }
  }
